/* eslint-disable react/display-name */
import React, { useEffect, useState } from "react";
import { Col, Row, Card, Table, Alert, Avatar, Tag, Switch } from "antd";
import Auxiliary from "util/Auxiliary";
import StudentProfileCard from "../../../components/Widgets/StudentProfileCard";
import { getStudentPracticeSessions } from "../../../appRedux/sagas/Dashboard";
import { useDispatch, useSelector } from "react-redux";
import { practice_session_columns, challenge_session_columns, class_session_columns, class_session_students_columns, question_response_columns } from "./data";
import DummyContentAlert from "../../../util/DummyContentAlert";
import { getClassAssignmentSession } from "../../../appRedux/actions/Dashboard";
import moment from 'moment'
import { getFormattedFromStamp } from "../../../util/DateUtil";
import H5PQuestion from "../../../components/Question/H5PQuestion";
import Modal from "antd/lib/modal/Modal";
import StudentResponseModal from "./StudentResponseModal";
import FlipMove from 'react-flip-move';
import QuizAttemptCard from "./QuizAttemptCard";
import { shuffle, sortBy } from "lodash";
import { disableSelection, enableSelection } from "../../../util/DisableSelection";
import { NotificationManager } from "react-notifications";

const ClassSession = ({ match }) => {
  const { class_session = null, teacher_details } = useSelector(({ dashboard }) => dashboard);
  const [processedSession, setProcessedSession] = useState({})
  const [showResponseModal, setShowResponseModal] = useState(false)
  const [reportQuestion, setReportQuestion] = useState(null)
  const [showAnswers,setShowAnswers] = useState(false)
  // const student = practice_sessions ? practice_sessions.student : {}
  // console.log(match)
  const { session_id } = match.params
  let processed_session = {}
  /**
   * combines the session information for display
   */
  const processSession = () => {
    if (!class_session) {
      setProcessedSession({})
      return
    }
    const { question_details = [], students = [], status } = class_session;
    const class_total_count = students.length;
    question_details.forEach(question => {
      question['attemptedCount'] = question.correct_attempts.length + question.incorrect_attempts.length
    })
    let attemptedSet = new Set()
    question_details.forEach(question => [...question.correct_attempts].concat(...question.incorrect_attempts).forEach(s => { attemptedSet.add(s) }))
    // total student count for table
    question_details.forEach(q => { q['total_count'] = class_total_count })
    console.log(attemptedSet)
    const class_attempted_count = attemptedSet.size
    processed_session = {
      class_total_count, class_attempted_count, question_details, students
    }
    //  add attempts data to student for tables
    let student_attempt_data = {}
    const update_attempt_count = (student_id, status) => {
      if (!student_attempt_data[student_id]) {
        student_attempt_data[student_id] = { "total": 0, "correct": 0 }
      }
      student_attempt_data[student_id]["total"] = student_attempt_data[student_id]["total"] + 1
      if (student_attempt_data[student_id]) {
        if (status)
          student_attempt_data[student_id]["correct"] = student_attempt_data[student_id]["correct"] + 1
      }
    }
    question_details.forEach(question => {
      question.correct_attempts.forEach(student_id => {
        update_attempt_count(student_id, true)
      });
      question.incorrect_attempts.forEach(student_id => {
        update_attempt_count(student_id, false)
      });
    })
    students.forEach(s => { s['attempts'] = student_attempt_data[s.id] })
    setProcessedSession({ ...processed_session, students: sortBy(students, "points").reverse() })
  }
  const dispatch = useDispatch()

  useEffect(() => {
    disableSelection("#page_body_container")
    return ()=>{enableSelection("#page_body_container")}
  }, [])
  useEffect(() => {
    dispatch(getClassAssignmentSession(session_id))
  }, session_id)

  useEffect(() => {
    if (class_session) {
      processSession()
      const { status } = class_session || {};
      setTimeout(() => {
        if (status !== 'completed') {
          dispatch(getClassAssignmentSession(session_id))
        }
      }, 5000);
    }
  }, [class_session])

  const renderStudentResponseModal = (question) => {
    const { students } = processSession;
    const responses = question.correct_attempts.map(student_id => {
      const student = students.filter(s => s.id === student_id)[0]
      return { student, status: true }
    }).concat(
      question.incorrect_attempts.map(student_id => {
        const student = students.filter(s => s.id === student_id)[0]
        return { student, status: false }
      })
    )
    return (<Modal
      visible={showResponseModal}
      title="Question Attempt Details"
      centered
      onOk={() => setShowResponseModal(false)}
      onCancel={() => setShowResponseModal(false)}
      okButtonProps={{ visible: false }}
      cancelButtonProps={{ visible: false }}
      footer={false}
    >
      <Table dataSource={responses} columns={question_response_columns} />
    </Modal>)
  }
  const get_class_session_columns = () => {
    // return []
    const { status } = class_session;
    const highlightAnswer = showAnswers || status === 'completed' ? true : false;
    const question_column = {
      title: 'Question',
      dataIndex: 'question_id',
      key: 'question_id',
      width: 400,
      render: (question_id, question) => (<div>
        <H5PQuestion question_guid={question_id} highlightAnswer={highlightAnswer} question_meta={question} />
      </div>),
    }
    const accuracy_column = {
      title: 'Accuracy',
      dataIndex: 'correct_attempts',
      key: 'correct_attempts',
      width: 80,
      render: (text, item) => {
        let tagColor = "orange";
        const accuracy = parseInt(item.correct_attempts.length) / parseInt(item.total_count) * 100
        if (accuracy >= 70) tagColor = "#87d068"
        else if (accuracy <= 20) tagColor = "rgb(230, 100, 100)"

        return <Tag color={tagColor}
          onClick={() => { setReportQuestion(item); setShowResponseModal(true) }}>
          {`${item.correct_attempts.length}/${item.total_count}`}
        </Tag>
      }
    }
    return [question_column, accuracy_column]
  }

  const { status } = class_session || {};
  return (
    <Auxiliary>
      <Row>
        <DummyContentAlert subscribed={teacher_details ? teacher_details.subscribed : false} />
      </Row>
      {class_session && <Auxiliary>
        <Row>
          <Col xl={12} lg={12} md={12} sm={24} xs={24}>
            <Card>
            {status !== 'completed'  && <Switch
              style={{ position: "absolute", right: 5, top: 5 }}
              checkedChildren="Hide Answers"
              unCheckedChildren="Show Answers"
              defaultChecked
              onChange={(v) => setShowAnswers(!showAnswers)}
              checked={showAnswers}
              // className="gx-qn-switch"
              size={"small"}
            />}
              <Row>
                <Col xl={12} lg={12} md={12} sm={12} xs={24}>
                  <div style={{ display: "flex", flexDirection: "row" }}>
                    <span className="gx-mr-1 gx-mb-1" style={{ ...styles.info_title }}> Assigned By: </span>
                    <span className="gx-mr-1 gx-mb-1" style={{ ...styles.info_lable }}>{class_session.assigned_by}</span>
                  </div>
                </Col>
                <Col xl={12} lg={12} md={12} sm={12} xs={24}>
                  <div style={{ display: "flex", flexDirection: "row" }}>
                    <span className="gx-mr-1 gx-mb-1" style={{ ...styles.info_title }} > Date: </span>
                    <span className="gx-mr-1 gx-mb-1" style={{ ...styles.info_lable }} >{getFormattedFromStamp(parseInt(class_session.start_date))}</span>
                  </div>
                </Col>
                <Col xl={12} lg={12} md={12} sm={12} xs={24}>
                  <div style={{ display: "flex", flexDirection: "row" }}>
                    <span className="gx-mr-1 gx-mb-1" style={{ ...styles.info_title }}> Chapter: </span>
                    <span className="gx-mr-1 gx-mb-1" style={{ ...styles.info_lable }}>{class_session.chapter_name}</span>
                  </div>
                </Col>
                <Col xl={12} lg={12} md={12} sm={12} xs={24}>
                  <div style={{ display: "flex", flexDirection: "row" }}>
                    <span className="gx-mr-1 gx-mb-1" style={{ ...styles.info_title }}> Completed By: </span>
                    <span className="gx-mr-1 gx-mb-1" style={{ ...styles.info_lable }}>{`${processedSession.class_attempted_count}/${processedSession.class_total_count}`}</span>
                  </div>
                </Col>
              </Row>

            </Card>
          </Col>
          {class_session.url && (
            <Col xl={12} lg={12} md={12} sm={24} xs={24}>
              <Card >
                <Col>
                  <div style={{ display: "flex", flexDirection: "row" }}>
                    <span className="gx-mr-1 gx-mb-1" style={{ ...styles.info_title }}> Quiz Link: </span>
                    <span className="gx-mr-1 gx-mb-1" style={{ ...styles.info_lable }}>{class_session.url}</span>
                    <a className="icon icon-copy" onClick={() => { navigator.clipboard.writeText(class_session.url); NotificationManager.info("Link copied to clipboard.") }} />
                  </div>
                </Col>
              </Card>
            </Col>)}

        </Row>
        <Row id="page_body_container">
          <Col xl={12} lg={12} md={12} sm={24} xs={24}>
            {processedSession && processedSession.question_details &&
              <Card>
                <Table columns={get_class_session_columns()} dataSource={processedSession.question_details} pagination={false} size="middle"></Table>
              </Card>
            }
          </Col>
          <Col xl={12} lg={12} md={12} sm={24} xs={24}>
            {processedSession && processedSession.students && <Card>
              {/* <Table columns={class_session_students_columns} dataSource={processedSession.students} pagination={false} size="middle"></Table> */}
              <FlipMove>
                {processedSession.students.map(student => {
                  return (<QuizAttemptCard key={student.id} details={student} />)
                })}

              </FlipMove>
            </Card>}
          </Col>
        </Row>

      </Auxiliary>
      }
      {reportQuestion && <StudentResponseModal students={processedSession.students} question={reportQuestion} showResponseModal={showResponseModal} parentStateHook={setShowResponseModal} />}
    </Auxiliary>
  );
};
const styles = {
  info_lable: {
    // whiteSpace: "nowrap",
    fontSize: "12px",

  },
  info_title: {
    whiteSpace: "nowrap",
    fontSize: "12px",
    fontWeight: 400,
    color:"black"
  }
}
export default ClassSession;